import { all } from 'redux-saga/effects';

import type { SimpleRequestConfig } from 'modules/app/types';
import { simpleRequestsLoader } from 'modules/app/utils';
import * as actions from 'modules/tireScan/actions';
import * as types from 'modules/tireScan/actionTypes';
import type { FetchTireScanResponse } from 'modules/tireScan/types';

const simpleRequests: Record<string, SimpleRequestConfig> = {
  [types.FETCH_TIRE_SCAN_REQUEST]: {
    callbacks: {
      success: (data: FetchTireScanResponse, meta) => actions.fetchTireScansSuccess(data, meta),
      failure: (error, meta) => actions.fetchTireScansFailure(error, meta),
    },
    // The import modal renders the failure inline (ImportModal `apiError`); the default
    // failure toast would report the same error twice.
    notifications: { failure: () => undefined },
  },
};

export default function* tscanSagas() {
  yield all(simpleRequestsLoader(simpleRequests));
}
